import { createSelector } from "reselect";
import moment from "moment";

export const Types = {
  GET_REQUEST: "benefits/GET_REQUEST",
  GET_SUCCESS: "benefits/GET_SUCCESS",
  GET_FAILURE: "benefits/GET_FAILURE",

  GET_LIST_REQUEST: "benefits/GET_LIST_REQUEST",
  GET_LIST_SUCCESS: "benefits/GET_LIST_SUCCESS",
  GET_LIST_FAILURE: "benefits/GET_LIST_FAILURE",

  CREATE_REQUEST: "benefits/CREATE_REQUEST",
  CREATE_SUCCESS: "benefits/CREATE_SUCCESS",
  CREATE_FAILURE: "benefits/CREATE_FAILURE",

  UPDATE_REQUEST: "benefits/UPDATE_REQUEST",
  UPDATE_SUCCESS: "benefits/UPDATE_SUCCESS",
  UPDATE_FAILURE: "benefits/UPDATE_FAILURE",

  DELETE_REQUEST: "benefits/DELETE_REQUEST",
  DELETE_SUCCESS: "benefits/DELETE_SUCCESS",
  DELETE_FAILURE: "benefits/DELETE_FAILURE",

  GET_CATEGORIES_REQUEST: "benefits/GET_CATERGORIS_REQUEST",
  GET_CATEGORIES_SUCCESS: "benefits/GET_CATEGORIES_SUCCESS",
  GET_CATEGORIES_FAILURE: "benefits/GET_CATEGORIES_FAILURE",

  GET_CHANNELS_REQUEST: "benefits/GET_CHANNELS_REQUEST",
  GET_CHANNELS_SUCCESS: "benefits/GET_CHANNELS_SUCCESS",
  GET_CHANNELS_FAILURE: "benefits/GET_CHANNELS_FAILURE",

  GET_REGIONS_REQUEST: "benefits/GET_REGIONS_REQUEST",
  EXPORT_REPORT_REQUEST: "benefits/EXPORT_REPORT_REQUEST",
  GET_REGIONS_SUCCESS: "benefits/GET_REGIONS_SUCCESS",
  GET_REGIONS_FAILURE: "benefits/GET_REGIONS_FAILURE",

  GET_STORES_REQUEST: "benefits/GET_STORES_REQUEST",
  GET_STORES_SUCCESS: "benefits/GET_STORES_SUCCESS",
  GET_STORES_FAILURE: "benefits/GET_STORES_FAILURE",

  GET_COMMERCIAL_CAMPAIGN_REQUEST: "benefits/GET_COMMERCIAL_CAMPAIGN_REQUEST",
  GET_COMMERCIAL_CAMPAIGN_SUCCESS: "benefits/GET_COMMERCIAL_CAMPAIGN_SUCCESS",
  GET_COMMERCIAL_CAMPAIGN_FAILURE: "benefits/GET_COMMERCIAL_CAMPAIGN_FAILURE",

  GET_PRODUCT_TYPES_REQUEST: "benefits/GET_PRODUCT_TYPES_REQUEST",
  GET_PRODUCT_TYPES_SUCCESS: "benefits/GET_PRODUCT_TYPES_SUCCESS",
  GET_PRODUCT_TYPES_FAILURE: "benefits/GET_PRODUCT_TYPES_FAILURE",

  GET_SECTIONS_REQUEST: "benefits/GET_SECTIONS_REQUEST",
  GET_SECTIONS_SUCCESS: "benefits/GET_SECTIONS_SUCCESS",
  GET_SECTIONS_FAILURE: "benefits/GET_SECTIONS_FAILURE",

  GET_SUB_SECTIONS_REQUEST: "benefits/GET_SUB_SECTIONS_REQUEST",
  GET_SUB_SECTIONS_SUCCESS: "benefits/GET_SUB_SECTIONS_SUCCESS",
  GET_SUB_SECTIONS_FAILURE: "benefits/GET_SUB_SECTIONS_FAILURE",

  GET_PRODUCTS_REQUEST: "benefits/GET_PRODUCTS_REQUEST",
  GET_PRODUCTS_SUCCESS: "benefits/GET_PRODUCTS_SUCCESS",
  GET_PRODUCTS_FAILURE: "benefits/GET_PRODUCTS_FAILURE",

  GET_PASSIONS_REQUEST: "benefits/GET_PASSIONS_REQUEST",
  GET_PASSIONS_SUCCESS: "benefits/GET_PASSIONS_SUCCESS",
  GET_PASSIONS_FAILURE: "benefits/GET_PASSIONS_FAILURE",

  GET_SELLERS_REQUEST: "benefits/GET_SELLERS_REQUEST",
  GET_SELLERS_SUCCESS: "benefits/GET_SELLERS_SUCCESS",
  GET_SELLERS_FAILURE: "benefits/GET_SELLERS_FAILURE",

  GET_TYPES_REQUEST: "benefits/GET_TYPES_REQUEST",
  GET_TYPES_SUCCESS: "benefits/GET_TYPES_SUCCESS",
  GET_TYPES_FAILURE: "benefits/GET_TYPES_FAILURE",

  SEARCH_REQUEST: "benefits/SEARCH_REQUEST",
  SEARCH_SUCCESS: "benefits/SEARCH_SUCCESS",
  SEARCH_FAILURE: "benefits/SEARCH_FAILURE",

  APPROVE_REQUEST: "benefits/APPROVE_REQUEST",
  APPROVE_SUCCESS: "benefits/APPROVE_SUCCESS",
  APPROVE_FAILURE: "benefits/APPROVE_FAILURE",

  REPPROVE_REQUEST: "benefits/REPPROVE_REQUEST",
  REPPROVE_SUCCESS: "benefits/REPPROVE_SUCCESS",
  REPPROVE_FAILURE: "benefits/REPPROVE_FAILURE",
};

const initialState = {
  data: [],
  loading: true,
  page: 1,
  totals: 1,

  detail: {
    data: {},
    loading: true,
  },

  create: {
    loading: false,
  },

  update: {
    loading: false,
  },

  delete: {
    loading: false,
  },

  channels: {
    data: [],
    loading: true,
  },

  regions: {
    data: [],
    loading: true,
  },

  stores: {
    data: [],
    loading: true,
  },

  categories: {
    data: [],
    loading: true,
  },

  commercialCampaigns: {
    data: [],
    loading: true,
  },

  productTypes: {
    data: [],
    loading: true,
  },

  sections: {
    data: [],
    loading: true,
  },

  subSections: {
    data: [],
    loading: true,
  },

  products: {
    data: [],
    loading: true,
  },

  passions: {
    data: [],
    loading: true,
  },

  sellers: {
    data: [],
    loading: true,
  },

  types: {
    data: [],
    loading: true,
  },

  search: {
    data: [],
    loading: false,
  },

  approve: {
    loading: false,
  },

  repprove: {
    loading: false,
  },
};

export default function benefits(state = initialState, action) {
  switch (action.type) {
    case Types.GET_REQUEST:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
        },
      };
    case Types.GET_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload.benefit.data,
        },
      };
    case Types.GET_FAILURE:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
        },
      };
    case Types.GET_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.benefits.data,
        page: action.payload.benefits.meta.current_page,
        totals: action.payload.benefits.meta.total_pages,
        total_benefits: action.payload.benefits.meta.total_count,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case Types.CREATE_REQUEST:
      return {
        ...state,
        create: {
          ...state.create,
          loading: true,
        },
      };
    case Types.CREATE_SUCCESS:
    case Types.CREATE_FAILURE:
      return {
        ...state,
        create: {
          ...state.create,
          loading: false,
        },
      };
    case Types.UPDATE_REQUEST:
      return {
        ...state,
        update: {
          ...state.update,
          loading: true,
        },
      };
    case Types.UPDATE_SUCCESS:
    case Types.UPDATE_FAILURE:
      return {
        ...state,
        update: {
          ...state.update,
          loading: false,
        },
      };
    case Types.GET_CATEGORIES_REQUEST:
      return {
        ...state,
        categories: {
          ...state.categories,
          loading: true,
        },
      };
    case Types.GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: {
          ...state.categories,
          loading: false,
          data: action.payload.categories.data,
        },
      };
    case Types.GET_CATEGORIES_FAILURE:
      return {
        ...state,
        categories: {
          ...state.categories,
          loading: false,
        },
      };
    case Types.GET_CHANNELS_REQUEST:
      return {
        ...state,
        channels: {
          ...state.channels,
          loading: true,
        },
      };
    case Types.GET_CHANNELS_SUCCESS:
      return {
        ...state,
        channels: {
          ...state.channels,
          loading: false,
          data: action.payload.channels.data,
        },
      };
    case Types.GET_CHANNELS_FAILURE:
      return {
        ...state,
        channels: {
          ...state.channels,
          loading: false,
        },
      };
    case Types.GET_COMMERCIAL_CAMPAIGN_REQUEST:
      return {
        ...state,
        commercialCampaigns: {
          ...state.commercialCampaigns,
          loading: true,
        },
      };
    case Types.GET_COMMERCIAL_CAMPAIGN_SUCCESS:
      return {
        ...state,
        commercialCampaigns: {
          ...state.commercialCampaigns,
          loading: false,
          data: action.payload.commercialCampaigns.data,
        },
      };
    case Types.GET_COMMERCIAL_CAMPAIGN_FAILURE:
      return {
        ...state,
        commercialCampaigns: {
          ...state.commercialCampaigns,
          loading: false,
        },
      };
    case Types.GET_REGIONS_REQUEST:
      return {
        ...state,
        regions: {
          ...state.regions,
          loading: true,
        },
      };
    case Types.EXPORT_REPORT_REQUEST:
      return {
        ...state,
        benefit: {
          ...state.benefit,
          loading: true,
        },
      };
    case Types.GET_REGIONS_SUCCESS:
      return {
        ...state,
        regions: {
          ...state.regions,
          loading: false,
          data: action.payload.regions.data,
        },
      };
    case Types.GET_REGIONS_FAILURE:
      return {
        ...state,
        regions: {
          ...state.regions,
          loading: false,
        },
      };
    case Types.GET_STORES_REQUEST:
      return {
        ...state,
        stores: {
          ...state.stores,
          loading: true,
        },
      };
    case Types.GET_STORES_SUCCESS:
      return {
        ...state,
        stores: {
          ...state.stores,
          loading: false,
          data: action.payload.stores.data,
        },
      };
    case Types.GET_STORES_FAILURE:
      return {
        ...state,
        stores: {
          ...state.stores,
          loading: false,
        },
      };
    case Types.GET_PRODUCT_TYPES_REQUEST:
      return {
        ...state,
        productTypes: {
          ...state.productTypes,
          loading: true,
        },
      };
    case Types.GET_PRODUCT_TYPES_SUCCESS:
      return {
        ...state,
        productTypes: {
          ...state.productTypes,
          loading: false,
          data: action.payload.productTypes.data,
        },
      };
    case Types.GET_PRODUCT_TYPES_FAILURE:
      return {
        ...state,
        productTypes: {
          ...state.productTypes,
          loading: false,
        },
      };
    case Types.GET_SECTIONS_REQUEST:
      return {
        ...state,
        sections: {
          ...state.sections,
          loading: true,
        },
      };
    case Types.GET_SECTIONS_SUCCESS:
      return {
        ...state,
        sections: {
          ...state.sections,
          loading: false,
          data: action.payload.sections.data,
        },
      };
    case Types.GET_SECTIONS_FAILURE:
      return {
        ...state,
        sections: {
          ...state.sections,
          loading: false,
        },
      };
    case Types.GET_SUB_SECTIONS_REQUEST:
      return {
        ...state,
        subSections: {
          ...state.subSections,
          loading: true,
        },
      };
    case Types.GET_SUB_SECTIONS_SUCCESS:
      return {
        ...state,
        subSections: {
          ...state.subSections,
          loading: false,
          data: action.payload.subSections.data,
        },
      };
    case Types.GET_SUB_SECTIONS_FAILURE:
      return {
        ...state,
        subSections: {
          ...state.subSections,
          loading: false,
        },
      };
    case Types.GET_PRODUCTS_REQUEST:
      return {
        ...state,
        products: {
          ...state.products,
          loading: true,
        },
      };
    case Types.GET_PRODUCTS_SUCCESS:
      return {
        ...state,
        products: {
          ...state.products,
          loading: false,
          data: action.payload.products.data,
        },
      };
    case Types.GET_PRODUCTS_FAILURE:
      return {
        ...state,
        products: {
          ...state.products,
          loading: false,
        },
      };
    case Types.GET_PASSIONS_REQUEST:
      return {
        ...state,
        passions: {
          ...state.passions,
          loading: true,
        },
      };
    case Types.GET_PASSIONS_SUCCESS:
      return {
        ...state,
        passions: {
          ...state.passions,
          loading: false,
          data: action.payload.passions.data,
        },
      };
    case Types.GET_PASSIONS_FAILURE:
      return {
        ...state,
        passions: {
          ...state.passions,
          loading: false,
        },
      };
    case Types.GET_SELLERS_REQUEST:
      return {
        ...state,
        sellers: {
          ...state.sellers,
          loading: true,
        },
      };
    case Types.GET_SELLERS_SUCCESS:
      return {
        ...state,
        sellers: {
          ...state.sellers,
          loading: false,
          data: action.payload.sellers.data,
        },
      };
    case Types.GET_SELLERS_FAILURE:
      return {
        ...state,
        sellers: {
          ...state.sellers,
          loading: false,
        },
      };
    case Types.GET_TYPES_REQUEST:
      return {
        ...state,
        types: {
          ...state.types,
          loading: true,
        },
      };
    case Types.GET_TYPES_SUCCESS:
      return {
        ...state,
        types: {
          ...state.types,
          loading: false,
          data: action.payload.types.data,
        },
      };
    case Types.GET_TYPES_FAILURE:
      return {
        ...state,
        types: {
          ...state.types,
          loading: false,
        },
      };
    case Types.SEARCH_REQUEST:
      return {
        ...state,
        search: {
          ...state.search,
          loading: true,
        },
      };
    case Types.SEARCH_SUCCESS:
      return {
        ...state,
        search: {
          ...state.search,
          loading: false,
          data: action.payload.benefits.data,
        },
      };
    case Types.SEARCH_FAILURE:
      return {
        ...state,
        search: {
          ...state.search,
          loading: false,
        },
      };
    case Types.APPROVE_REQUEST:
      return {
        ...state,
        approve: {
          ...state.approve,
          loading: true,
        },
      };
    case Types.APPROVE_SUCCESS:
    case Types.APPROVE_FAILURE:
      return {
        ...state,
        approve: {
          ...state.approve,
          loading: false,
        },
      };
    case Types.REPPROVE_REQUEST:
      return {
        ...state,
        repprove: {
          ...state.repprove,
          loading: true,
        },
      };
    case Types.REPPROVE_SUCCESS:
    case Types.REPPROVE_FAILURE:
      return {
        ...state,
        repprove: {
          ...state.repprove,
          loading: false,
        },
      };
    default:
      return state;
  }
}

export const Creators = {
  getBenefitRequest: (id) => ({
    type: Types.GET_REQUEST,
    payload: { id },
  }),

  getBenefitSuccess: (benefit) => ({
    type: Types.GET_SUCCESS,
    payload: { benefit },
  }),

  getBenefitFailure: () => ({
    type: Types.GET_FAILURE,
  }),

  getBenefitsRequest: (page = 1, filters = null) => ({
    type: Types.GET_LIST_REQUEST,
    payload: { page, filters },
  }),

  getBenefitsSuccess: (benefits) => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { benefits },
  }),

  getBenefitsFailure: () => ({
    type: Types.GET_LIST_FAILURE,
  }),

  createBenefitRequest: (data) => ({
    type: Types.CREATE_REQUEST,
    payload: { data },
  }),

  createBenefitSuccess: () => ({
    type: Types.CREATE_SUCCESS,
  }),

  createBenefitFailure: () => ({
    type: Types.CREATE_FAILURE,
  }),

  updateBenefitRequest: (id, data) => ({
    type: Types.UPDATE_REQUEST,
    payload: { id, data },
  }),

  updateBenefitSuccess: () => ({
    type: Types.UPDATE_SUCCESS,
  }),

  updateBenefitFailure: () => ({
    type: Types.UPDATE_FAILURE,
  }),

  deleteBenefitRequest: (id) => ({
    type: Types.DELETE_REQUEST,
    payload: { id },
  }),

  deleteBenefitSuccess: () => ({
    type: Types.DELETE_SUCCESS,
  }),

  deletebenefitFailure: () => ({
    type: Types.DELETE_FAILURE,
  }),

  getBenefitCategoriesRequest: (query = "") => ({
    type: Types.GET_CATEGORIES_REQUEST,
    payload: { query },
  }),

  getBenefitCategoriesSuccess: (categories) => ({
    type: Types.GET_CATEGORIES_SUCCESS,
    payload: { categories },
  }),

  getBenefitCategoriesFailure: () => ({
    type: Types.GET_CATEGORIES_FAILURE,
  }),

  getBenefitChannelsRequest: (query = "") => ({
    type: Types.GET_CHANNELS_REQUEST,
    payload: { query },
  }),

  getBenefitChannelsSuccess: (channels) => ({
    type: Types.GET_CHANNELS_SUCCESS,
    payload: { channels },
  }),

  getBenefitChannelsFailure: () => ({
    type: Types.GET_CHANNELS_FAILURE,
  }),

  getBenefitCommercialCampaignsRequest: (query = "", active = undefined) => ({
    type: Types.GET_COMMERCIAL_CAMPAIGN_REQUEST,
    payload: { query, active },
  }),

  getBenefitCommercialCampaignsSuccess: (commercialCampaigns) => ({
    type: Types.GET_COMMERCIAL_CAMPAIGN_SUCCESS,
    payload: { commercialCampaigns },
  }),

  getBenefitCommercialCampaignsFailure: () => ({
    type: Types.GET_COMMERCIAL_CAMPAIGN_FAILURE,
  }),

  getBenefitRegionsRequest: (query = "") => ({
    type: Types.GET_REGIONS_REQUEST,
    payload: { query },
  }),

  exportReportBenefitsRequest: (query = "") => ({
    type: Types.EXPORT_REPORT_REQUEST,
    payload: { query },
  }),

  getBenefitRegionsSuccess: (regions) => ({
    type: Types.GET_REGIONS_SUCCESS,
    payload: { regions },
  }),

  getBenefitRegionsFailure: () => ({
    type: Types.GET_REGIONS_FAILURE,
  }),

  getBenefitStoresRequest: (query = "", region = null) => ({
    type: Types.GET_STORES_REQUEST,
    payload: { query, region },
  }),

  getBenefitStoresSuccess: (stores) => ({
    type: Types.GET_STORES_SUCCESS,
    payload: { stores },
  }),

  getBenefitStoresFailure: () => ({
    type: Types.GET_STORES_FAILURE,
  }),

  getBenefitProductTypesRequest: (query = "") => ({
    type: Types.GET_PRODUCT_TYPES_REQUEST,
    payload: { query },
  }),

  getBenefitProductTypesSuccess: (productTypes) => ({
    type: Types.GET_PRODUCT_TYPES_SUCCESS,
    payload: { productTypes },
  }),

  getBenefitProductTypesFailure: () => ({
    type: Types.GET_PRODUCT_TYPES_FAILURE,
  }),

  getBenefitSectionsRequest: (query = "") => ({
    type: Types.GET_SECTIONS_REQUEST,
    payload: { query },
  }),

  getBenefitSectionsSuccess: (sections) => ({
    type: Types.GET_SECTIONS_SUCCESS,
    payload: { sections },
  }),

  getBenefitSectionsFailure: () => ({
    type: Types.GET_SECTIONS_FAILURE,
  }),

  getBenefitSubSectionsRequest: (query = "", section = null) => ({
    type: Types.GET_SUB_SECTIONS_REQUEST,
    payload: { query, section },
  }),

  getBenefitSubSectionsSuccess: (subSections) => ({
    type: Types.GET_SUB_SECTIONS_SUCCESS,
    payload: { subSections },
  }),

  getBenefitSubSectionsFailure: () => ({
    type: Types.GET_SUB_SECTIONS_FAILURE,
  }),

  getBenefitProductsRequest: (query = "") => ({
    type: Types.GET_PRODUCTS_REQUEST,
    payload: { query },
  }),

  getBenefitProductsSuccess: (products) => ({
    type: Types.GET_PRODUCTS_SUCCESS,
    payload: { products },
  }),

  getBenefitProductsFailure: () => ({
    type: Types.GET_PRODUCTS_FAILURE,
  }),

  getBenefitPassionsRequest: (query = "") => ({
    type: Types.GET_PASSIONS_REQUEST,
    payload: { query },
  }),

  getBenefitPassionsSuccess: (passions) => ({
    type: Types.GET_PASSIONS_SUCCESS,
    payload: { passions },
  }),

  getBenefitPassionsFailure: () => ({
    type: Types.GET_PASSIONS_FAILURE,
  }),

  getBenefitSellersRequest: (query = "") => ({
    type: Types.GET_SELLERS_REQUEST,
    payload: { query },
  }),

  getBenefitSellersSuccess: (sellers) => ({
    type: Types.GET_SELLERS_SUCCESS,
    payload: { sellers },
  }),

  getBenefitSellersFailure: () => ({
    type: Types.GET_SELLERS_FAILURE,
  }),

  getBenefitTypesRequest: (query = "", status_value = null) => ({
    type: Types.GET_TYPES_REQUEST,
    payload: { query, status_value },
  }),

  getBenefitTypesSuccess: (types) => ({
    type: Types.GET_TYPES_SUCCESS,
    payload: { types },
  }),

  getBenefitTypesFailure: () => ({
    type: Types.GET_TYPES_FAILURE,
  }),

  searchBenefitsRequest: (filters = null) => ({
    type: Types.SEARCH_REQUEST,
    payload: { filters },
  }),

  searchBenefitsSuccess: (benefits) => ({
    type: Types.SEARCH_SUCCESS,
    payload: { benefits },
  }),

  searchBenefitsFailure: () => ({
    type: Types.SEARCH_FAILURE,
  }),

  approveBenefitRequest: (id, data) => ({
    type: Types.APPROVE_REQUEST,
    payload: { id, data },
  }),

  approveBenefitSuccess: () => ({
    type: Types.APPROVE_SUCCESS,
  }),

  approveBenefitFailure: () => ({
    type: Types.APPROVE_FAILURE,
  }),

  repproveBenefitRequest: (id, data) => ({
    type: Types.REPPROVE_REQUEST,
    payload: { id, data },
  }),

  repproveBenefitSuccess: () => ({
    type: Types.REPPROVE_SUCCESS,
  }),

  repproveBenefitFailure: () => ({
    type: Types.REPPROVE_FAILURE,
  }),
};

const getStatus = (benefit) => {
  switch (benefit.attributes.voucher_status) {
    case "approve":
      return { label: "Aprovado", className: "label-active" };
    case "reproved":
      return { label: "Reprovado", className: "label-inactive" };
    case "processing":
      return { label: "Processando", className: "label-processing" };
    case "failed":
      return { label: "Falho", className: "label-inactive" };
    case "expired":
      return { label: "Expirado", className: "label-inactive" };
    default:
      return { label: "Pendente", className: "label-pendent" };
  }
};

export const Selectors = {
  benefits: createSelector(
    (state) => state,
    (benefits) =>
      benefits.map((benefit) => ({
        ...benefit,
        attributes: {
          ...benefit.attributes,
          stores:
            !!benefit.attributes.places.length &&
            benefit.attributes.places.map((place) => place.name).join(", "),
          period: `${moment
            .utc(benefit.attributes.start_at)
            .utcOffset("-03:00")
            .format("DD/MM/YYYY HH:mm")} - ${moment
            .utc(benefit.attributes.end_at)
            .utcOffset("-03:00")
            .format("DD/MM/YYYY HH:mm")}`,
          status: getStatus(benefit),
          category: benefit.attributes.category
            ? benefit.attributes.category.title
            : null,
          description: benefit.description,
        },
      }))
  ),

  categories: createSelector(
    (state) => state,
    (categories) =>
      categories.map((category) => ({
        value: category.id,
        label: category.attributes.title,
      }))
  ),

  channels: createSelector(
    (state) => state,
    (channels) =>
      channels.map((channel) => ({
        value: channel.id,
        label: channel.attributes.name,
      }))
  ),

  activeChannels: createSelector(
    (state) => state,
    (channels) =>
      channels
        .filter((channel) => channel.attributes.score)
        .map((channel) => ({
          value: channel.id,
          label: channel.attributes.name,
        }))
  ),

  commercialCampaigns: createSelector(
    (state) => state,
    (commercialCampaigns) =>
      commercialCampaigns.map((commercialCampaign) => ({
        value: commercialCampaign.id,
        label: commercialCampaign.attributes.title,
      }))
  ),

  regions: createSelector(
    (state) => state,
    (regions) =>
      regions.map((region) => ({
        value: region.id,
        label: region.attributes.name,
      }))
  ),

  stores: createSelector(
    (state) => state,
    (stores) =>
      stores.map((store) => ({
        value: store.id,
        label: store.attributes.name,
      }))
  ),

  productTypes: createSelector(
    (state) => state,
    (productTypes) =>
      productTypes.map((productType) => ({
        value: productType.id,
        label: productType.attributes.name,
        external_id: productType.attributes.external_id,
      }))
  ),

  sections: createSelector(
    (state) => state,
    (sections) =>
      sections.map((section) => ({
        value: section.id,
        label: section.attributes.name,
        external_id: section.attributes.external_id,
      }))
  ),

  subSections: createSelector(
    (state) => state,
    (subSections) =>
      subSections.map((subSection) => ({
        value: subSection.id,
        label: subSection.attributes.name,
        external_id: subSection.attributes.external_id,
        subSection,
      }))
  ),

  products: createSelector(
    (state) => state,
    (products) =>
      products.map((product) => ({
        value: product.id,
        label: `${product.attributes.sku} (${product.attributes.name})`,
        external_id: product.attributes.external_id,
        sku: product.attributes.sku,
      }))
  ),

  passions: createSelector(
    (state) => state,
    (passions) =>
      passions.map((passion) => ({
        value: passion.id,
        label: passion.attributes.title,
      }))
  ),

  sellers: createSelector(
    (state) => state,
    (sellers) =>
      sellers.map((seller) => ({
        value: seller.id,
        label:
          seller.attributes &&
          seller.attributes.extra_data &&
          seller.attributes.extra_data.message_content
            ? seller.attributes.extra_data.message_content.SHOP_NAME
            : "Não identificado",
      }))
  ),

  types: createSelector(
    (state) => state,
    (types) =>
      types.map((type) => ({
        value: type.id,
        label: type.attributes.title,
      }))
  ),

  options: createSelector(
    (state) => state,
    (benefits) =>
      benefits.map((benefit) => ({
        value: benefit.id,
        label: benefit.title,
      }))
  ),
};
